<template>

  <div class="container">

    <div class="inner-view" v-if="checked">
    </div>
    <div v-else class="outer-view"></div>

  </div>

  </div>


</template>

<script>

export default {

  name: 'RadioView',

  data () {
    return {}
  },
  props: {
    checked: false
  }
}

</script>

<style scoped>

.container {
  width: 1.31rem;
  height: 1.31rem;
}

.outer-view {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  border: 0.03rem solid rgba(20, 20, 20, 0.20);
  /*box-sizing: border-box;*/
}

.inner-view {
  width: 1.26rem;
  height: 1.26rem;
  /*border-radius: 50%;*/
  background: url(../../assets/select.png);
  background-size: 1.26rem 1.26rem;
}


</style>



// WEBPACK FOOTER //
// src/components/widgets/RadioView.vue